import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="custom-header-nav">
      {/* ✅ Logo does full refresh */}
      <a href="/">
        <img
          src={logo}
          alt="Logo"
          style={{ height: '50px', marginRight: '20px' }}
        />
      </a>

      <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        {/* ✅ HOME link also fully reloads */}
        <a href="/">HOME</a>
        <span className="divider">/</span>

        {/* ✅ Other links use client-side routing */}
        <Link to="/about">ABOUT US</Link>
        <span className="divider">/</span>
        <Link to="/news">NEWS</Link>
        <span className="divider">/</span>
        <Link to="/tickets">TICKETS</Link>
        <span className="divider">/</span>
        <Link to="/contact">CONTACT US</Link>
        <span className="divider">/</span>
        <Link to="/buy" className="buy-button">BUY TICKETS</Link>
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </div>
  );
};

export default Header;
